import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { backendApi } from "../../../api/apiService";

function AddSkillsPopup({ onclose, onload, id, name }) {
  const [skillName, setSkillName] = useState("");
  useEffect(() => {
    if (name) {
      setSkillName(name);
    }
  }, [name]);

  const DesignationSave = () => {
    if (skillName === "") {
      toast.warn("Please enter an skillName:", { containerId: "F" });
      return false;
    }
    var req = {
      functionName: "addUpdateSkill",
      siteId: localStorage.getItem("siteId"),
      skillName: skillName,
      ...(id && { skillId: id }),
    };
    backendApi(req).then((response) => {
      console.log(response);
      if (response.success == 1) {
        toast.success("Saved successsfully", { containerId: "D" });
        onclose();
        onload();
      } else {
        toast.warn("Error Saving status.", { containerId: "F" });
        return false;
      }
    });
  };

  return (
    <div className="modal_parent">
      <div className="module_popup addPeople bfAddPeople">
        <div className="module_innerpopup module_bodypop">
          <div className="module_headdiv">
            <h4 className="popup_head mb-2">New Skill</h4>
          </div>
          <div className="module_body" style={{ overflowX: "hidden" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="input-group input-group-outline mb-2 location_search">
                  <label htmlFor="" className="form-label">
                    Skill
                  </label>
                  <div className="col-md-12 p-0 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Skill Name..."
                      value={skillName}
                      onChange={(e) => setSkillName(e.target.value)}
                    />
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>

          <div className="childIssueses my-2">
            {id == "" ? (
              <button
                className="btn-btn btn btn-btn2 btn-sm me-2"
                onClick={DesignationSave}
              >
                Save
              </button>
            ) : (
              <button
                className="btn-btn btn btn-btn2 btn-sm me-2"
                onClick={DesignationSave}
              >
                Update
              </button>
            )}

            <button
              className="btn-btn btn btn-btn1 btn-sm"
              onClick={() => {
                setSkillName("");
                onclose();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddSkillsPopup;
